import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Next = class Next extends Vue {
    constructor() {
        super(...arguments);
        this.backgroundColor = this.$store.getters.colors.backgroundColor;
        this.textColor = this.$store.getters.colors.textColor;
    }
    get sizeRules() {
        return `height: ${this.size}; width: ${this.size}; line-height: ${this.size};`;
    }
    get colorsRules() {
        return `background-color: ${this.backgroundColor}; color: ${this.textColor};`;
    }
    click() {
        this.$emit("click");
    }
};
__decorate([
    Prop({ default: "25px" })
], Next.prototype, "size", void 0);
Next = __decorate([
    Component
], Next);
export default Next;
